import { TextCell } from 'common/components/ConfigurableTable/Components/Cells/TextCell';
import { ColumnConfiguration } from 'src/common/components/ConfigurableTable/models/configurableTable';

import { SecondaryConfigurableTable } from 'common/components/ConfigurableTable/SecondaryConfigurableTable';
import { RsimProfileStatus } from 'rSimInventory/RSimApi/rSimApi.interface';
import styled from '@emotion/styled';
import { RSimSimPollingStatusCell } from '../Cells/RSimSimPollingStatusCell';
import { SimulateOutageCell } from '../Cells/SimulateOutageCell';
import { Routes } from 'src/Routes.constants';
import { useLocation, useNavigate } from 'react-router';
import { RSimSimIccidLinkCell } from './RSimSimIccidLinkCell';
import { DurationCell } from 'common/components/ConfigurableTable/Components/Cells/DurationCell';
import { useExtendSimWithDerivativeFromRSim } from './hooks/useExtendSimWithDerivativeFromRSim';
import { useColumnConfiguration } from './hooks/useColumnConfiguration';
import { SimProfileTagProvider } from 'simInventory/Tags/SimProfileTagProvider';
import { NumberCell } from 'src/common/components/ConfigurableTable/Components/Cells/NumberCell';

type RSimSimTableProps = {
  euicc: string;
  primaryIccid: string;
  secondaryIccid: string;
  status: RsimProfileStatus;
};

const RSimSimConfigurableTable = styled(SecondaryConfigurableTable)({
  '& .MuiDataGrid-cell[data-field="status"]': {
    border: 'none',
  },
});

export const RSimSimTable = ({
  euicc,
  primaryIccid,
  secondaryIccid,
  status,
}: RSimSimTableProps) => {
  const simInventoryWithStatus = useExtendSimWithDerivativeFromRSim(
    euicc,
    status,
    primaryIccid,
    secondaryIccid,
  );
  const configuration: ColumnConfiguration[] = useColumnConfiguration();

  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  return (
    <div data-testid="sims-inventory-table">
      <SimProfileTagProvider>
        <RSimSimConfigurableTable
          data-testid={`sim-inventory-${euicc}`}
          rows={simInventoryWithStatus || []}
          actions={[
            {
              label: 'View Details',
              type: 'custom',
              actionCallback: (data: any) => {
                navigate(`${Routes.simInventory}/${data.iccid}`, {
                  state: {
                    previousPath: `${pathname}${search}`,
                  },
                });
              },
            },
          ]}
          configuration={configuration}
          disablePagination
          getRowId={(row) => row.iccid}
          cellConfiguration={{
            default: TextCell,
            iccid: RSimSimIccidLinkCell,
            status: RSimSimPollingStatusCell,
            simulateOutage: SimulateOutageCell,
            outMinuteUsage: DurationCell,
            liveDataUsage: NumberCell,
            outTextUsage: NumberCell,
          }}
        />
      </SimProfileTagProvider>
    </div>
  );
};
